module.exports = __webpack_public_path__ + "static/media/firebase.bfa69c4f.svg";